import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-2xl lg:text-3xl font-extrabold mb-2 text-secondary-300" }, "Please provide us with a soft quote", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-base lg:text-xl" }, "Let's set expectations for the borrower", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-b py-2 mt-4 md:mt-6 mb-4 md:mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs md:text-base md:leading-6 font-medium text-gray-500" }, "Offer details")
], -1)
const _hoisted_7 = { class: "mb-4 w-80" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "loan-amount"
}, " Loan Amount ", -1)
const _hoisted_9 = { class: "w-full relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "$")
], -1)
const _hoisted_11 = { class: "flex items-start space-x-4 mb-4" }
const _hoisted_12 = { class: "w-80" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "max-ltv"
}, " Max LTV ", -1)
const _hoisted_14 = { class: "w-full relative" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "%")
], -1)
const _hoisted_16 = { class: "w-80" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "max-ltc"
}, " Max LTC ", -1)
const _hoisted_18 = { class: "w-full relative" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "%")
], -1)
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "term"
}, " Term ", -1)
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = { class: "inline-flex items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Fixed", -1)
const _hoisted_25 = { class: "inline-flex items-center ml-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Floating", -1)
const _hoisted_27 = { class: "flex items-start space-x-4 mb-4" }
const _hoisted_28 = { class: "w-80" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "term-years"
}, " Term (Years) ", -1)
const _hoisted_30 = { class: "w-80" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "amortization-years"
}, " Amortization (Years) ", -1)
const _hoisted_32 = { class: "mb-4 w-80" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "index"
}, " Index ", -1)
const _hoisted_34 = { class: "mb-4 w-80" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "interest-rate"
}, " Start Interest Rate ", -1)
const _hoisted_36 = { class: "w-full relative" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "%")
], -1)
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "interest-only"
}, " Interest Only ", -1)
const _hoisted_40 = { class: "flex items-center" }
const _hoisted_41 = { class: "inline-flex items-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Yes", -1)
const _hoisted_43 = { class: "inline-flex items-center ml-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "No", -1)
const _hoisted_45 = {
  key: 0,
  class: "mb-4 max-w-xl"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "interest-only-details"
}, " Interest Only Details ", -1)
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "recourse"
}, " Recourse ", -1)
const _hoisted_49 = { class: "flex items-center" }
const _hoisted_50 = { class: "inline-flex items-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Yes", -1)
const _hoisted_52 = { class: "inline-flex items-center ml-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "No", -1)
const _hoisted_54 = { class: "inline-flex items-center ml-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Partial", -1)
const _hoisted_56 = {
  key: 1,
  class: "mb-4 max-w-xl"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "recourse-details"
}, " Recourse Details ", -1)
const _hoisted_58 = { class: "mb-4" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "prepayment-penalty"
}, " Prepayment Penalty ", -1)
const _hoisted_60 = { class: "flex items-center" }
const _hoisted_61 = { class: "inline-flex items-center" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Yes", -1)
const _hoisted_63 = { class: "inline-flex items-center ml-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "No", -1)
const _hoisted_65 = {
  key: 2,
  class: "mb-4 max-w-xl"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "prepayment-penalty-details"
}, " Prepayment Penalty Details ", -1)
const _hoisted_67 = { class: "mb-4 w-80" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "dscr"
}, " Minimum DSCR ", -1)
const _hoisted_69 = { class: "w-full relative" }
const _hoisted_70 = { class: "mb-4 w-80" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "prepayment-penalty"
}, " Lender Origination Fee ", -1)
const _hoisted_72 = { class: "w-full relative" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "%")
], -1)
const _hoisted_74 = { class: "max-w-xl mt-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "prepayment-penalty"
}, " Additional questions, comments and information ", -1)
const _hoisted_76 = { class: "flex items-center justify-start mt-3 md:mt-4" }
const _hoisted_77 = {
  type: "submit",
  class: "text-xs md:text-base text-white bg-green-600 hover:bg-green-800 rounded-md mr-4 py-2 px-4 focus:outline-none border-none"
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_select = _resolveComponent("base-select")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
  }, [
    (_ctx.questionsOnly === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.questionsOnly === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 pl-6 text-gray-700",
                id: "loan-amount",
                type: "text",
                placeholder: "1,000,000",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collectedData.loanAmount) = $event))
              }, null, 512), [
                [_vModelText, _ctx.collectedData.loanAmount]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700", {
                'border-red-600 focus:outline-none focus-visible:ring-0': _ctx.collectedData.maxLTV && parseInt(_ctx.collectedData.maxLTV) > 100 
              }]),
                  id: "max-ltv",
                  type: "text",
                  placeholder: "75.00",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collectedData.maxLTV) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.collectedData.maxLTV],
                  [_directive_maska, '###']
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700", {
                'border-red-600 focus:outline-none focus-visible:ring-0': _ctx.collectedData.maxLTC && parseInt(_ctx.collectedData.maxLTC) > 100 
              }]),
                  id: "max-ltc",
                  type: "text",
                  placeholder: "75.00",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.maxLTC) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.collectedData.maxLTC],
                  [_directive_maska, '###']
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "term",
                  value: "fixed",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.rateType) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.rateType]
                ]),
                _hoisted_24
              ]),
              _createElementVNode("label", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "term",
                  value: "floating",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collectedData.rateType) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.rateType]
                ]),
                _hoisted_26
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("input", {
                class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
                id: "term-years",
                type: "text",
                placeholder: "1 to 45",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.collectedData.termYears) = $event))
              }, null, 512), [
                [_directive_maska, '##'],
                [_vModelText, _ctx.collectedData.termYears]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("input", {
                class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
                id: "amortization-years",
                type: "text",
                placeholder: "1 to 45",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.collectedData.amortization) = $event))
              }, null, 512), [
                [_directive_maska, '##'],
                [_vModelText, _ctx.collectedData.amortization]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_base_select, {
              class: "mt-2 max-w-xs",
              options: ['Treasury', 'WSJP', 'SOFR', 'LIBOR', 'Other'],
              "clear-placeholder": false,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.collectedData.index = $event)),
              modelValue: _ctx.collectedData.index
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700", {
              'border-red-600 focus:outline-none focus-visible:ring-0': _ctx.collectedData.startInterestRate && (parseInt(_ctx.collectedData.startInterestRate) > 19 || !/^\d+(\.\d+)*$/.test(_ctx.collectedData.startInterestRate))
            }]),
                id: "interest-rate",
                type: "text",
                placeholder: "4.58",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.collectedData.startInterestRate) = $event))
              }, null, 2), [
                [_vModelText, _ctx.collectedData.startInterestRate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "interest-only",
                  value: true,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.collectedData.interestOnly) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.interestOnly]
                ]),
                _hoisted_42
              ]),
              _createElementVNode("label", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "interest-only",
                  value: false,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.collectedData.interestOnly) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.interestOnly]
                ]),
                _hoisted_44
              ])
            ])
          ]),
          (_ctx.collectedData.interestOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("textarea", {
                  id: "interest-only-details",
                  class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
                  rows: "3",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.collectedData.interestOnlyDetails) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.collectedData.interestOnlyDetails]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", _hoisted_50, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "recourse",
                  value: "Full",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.collectedData.recourse) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.recourse]
                ]),
                _hoisted_51
              ]),
              _createElementVNode("label", _hoisted_52, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "recourse",
                  value: "None",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.collectedData.recourse) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.recourse]
                ]),
                _hoisted_53
              ]),
              _createElementVNode("label", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "recourse",
                  value: "Partial",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.collectedData.recourse) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.recourse]
                ]),
                _hoisted_55
              ])
            ])
          ]),
          (_ctx.collectedData.recourse == 'Full' || _ctx.collectedData.recourse == 'Partial')
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _hoisted_57,
                _withDirectives(_createElementVNode("textarea", {
                  id: "recourse-details",
                  class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
                  rows: "3",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.collectedData.recourseDetails) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.collectedData.recourseDetails]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("label", _hoisted_61, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "prepayment-penalty",
                  value: true,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.collectedData.prepaymentPenalties) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.prepaymentPenalties]
                ]),
                _hoisted_62
              ]),
              _createElementVNode("label", _hoisted_63, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio cursor-pointer",
                  name: "prepayment-penalty",
                  value: false,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.collectedData.prepaymentPenalties) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.collectedData.prepaymentPenalties]
                ]),
                _hoisted_64
              ])
            ])
          ]),
          (_ctx.collectedData.prepaymentPenalties)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _hoisted_66,
                _withDirectives(_createElementVNode("textarea", {
                  id: "prepayment-penalty-details",
                  class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
                  rows: "3",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.collectedData.prepaymentDetails) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.collectedData.prepaymentDetails]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _withDirectives(_createElementVNode("input", {
                class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
                id: "dscr",
                type: "text",
                placeholder: "0.25",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.collectedData.dscr) = $event))
              }, null, 512), [
                [_vModelText, _ctx.collectedData.dscr],
                [_directive_maska, '#.##']
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700", {
              'border-red-600 focus:outline-none focus-visible:ring-0': _ctx.collectedData.originationFee && !/^\d+(\.\d+)*$/.test(_ctx.collectedData.originationFee)
            }]),
                id: "lender-origination-fee",
                type: "text",
                placeholder: "0.25",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.collectedData.originationFee) = $event))
              }, null, 2), [
                [_vModelText, _ctx.collectedData.originationFee]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_74, [
      _hoisted_75,
      _withDirectives(_createElementVNode("textarea", {
        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
        rows: "3",
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.collectedData.additionalDetails) = $event))
      }, null, 512), [
        [_vModelText, _ctx.collectedData.additionalDetails]
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("button", _hoisted_77, [
        (_ctx.questionsOnly === false)
          ? (_openBlock(), _createElementBlock("span", _hoisted_78, "Submit soft quote"))
          : _createCommentVNode("", true),
        (_ctx.questionsOnly === true)
          ? (_openBlock(), _createElementBlock("span", _hoisted_79, "Submit question"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}